<template>
<div class="container-fluid">	

	<page-loading v-if="!data_loaded" />

	<div v-else class="row">
		<div class="col-12">
			<div class="route card fill-app-height without-page-title d-flex flex-row" :class="config.layout" style="z-index:0;">

				<route-item-details
					v-if="config.layout === 'mobile'"
					:route="route"
					:routeDetails="false" />

				<route-item-stops
					:route="route"
					:data_loaded="data_loaded"
					@clear_checkin_modal="clearCheckinModal()" />

				<route-item-map
					:route="route"
					:data_loaded="data_loaded" />

			</div>
		</div>

		<checkin-view-modal :showing_checkin="showing_checkin" />

	</div>
</div>
</template>


<script>
    import { mapState } from 'vuex'
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	import RouteItemStops from '../../components/RouteItemStops'
	import RouteItemDetails from '../../components/RouteItemDetails'
	import RouteItemMap from '../../components/RouteItemMap'
	import CheckinViewModal from '../../components/CheckinViewModal'


	export default {
		mixins: [BreadcrumbsManager],

		components: {
            RouteItemStops,
            RouteItemDetails,
            RouteItemMap,
            CheckinViewModal,
        },

		props: {
			id: {
				type: Number,
				required: true,
			},
		},

		data () {
			return {
				data_loaded: false,
				route: {},
				checkin_options: {
	        		route: this.id,
	        		checkinables: null,
	        		ex_providers: null,
	        	},

	        	showing_checkin: {
					checkin_type: [], 
					checkin_user: [],
					physician: [],
					service_lines: [],
				},	        	
			}
		},

		created() {
			this.fetchRoute();	
		},

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Routes', to: { name: 'routes.index'} },
                { text: '[Route Name]', to: { name: 'routes.show'} },
            ]); 	
        },

		mounted() {
			this.$root.$on('route_stops_changed', data => {
				this.route.visits = data.visits;
				this.route.waypoints = data.waypoints;
				this.$root.$emit('rebuild_map');
			});

			this.$root.$on('route_completed', () => {
				this.route.status = 2;
				this.route.status_text = 'Complete';
				this.route.ended_on = moment();				
				Swal.fire({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    icon: 'success',
                    title: 'Route complete!',
                });
			});

			this.$root.$on('route_extended', () => {
				this.route.status = 1;
				this.route.status_text = 'In progress';
				this.route.ended_on = null;		
			});


			this.$root.$on('update_route', data => {
				this.updateRoute(data);
			});

			this.$root.$on('update_terminals', data => {
				this.updateTerminals(data);
			});

			//listens for modal updates in RouteItemStopsPlanned.vue
			this.$root.$on('update_checkin_options', data => {
		    	this.checkin_options.checkinables = data;
		    	this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
		    });

			this.$root.$on('checkinadded', data => {
				data.forEach(newCheckin => {
					this.route.checkins.push(newCheckin);

					//push the new route_visit object
					if (newCheckin.route_visit.type === 'extra') {
						this.route.visits.push(newCheckin.route_visit);
					}

					//push the new checkin_id into the appropriate visit
					var route_visit_index = this.route.visits.findIndex((element) => {
	                    return element.id === newCheckin.route_visit.id;
	                });				

				    this.route.visits[route_visit_index].checkin_id = newCheckin.id;
				});

				//on first checkin of any kind, set the status and starting time
				if (this.route.checkins.length === 1) {
					this.route.status = 1;
					this.route.status_text = 'In progress';
					this.route.started_on = moment();
				}
			});

			this.$root.$on('checkin_updated', data => {
		    	this.route.checkins.splice(this.checkinIndex(data.id), 1); //remove
		    	this.route.checkins.push(data); //re-add
		    	this.$root.$emit('show_checkin', data.id);//and re-load modal
  		    });

		    //find the checkin in the array and move it so it can be in props
		    this.$root.$on('show_checkin', id => { 		    	
		    	this.showing_checkin = this.route.checkins.find(checkins => { 
					return checkins.id === id;
				});
		    });
		},

		methods: {
			fetchRoute() {			
	            axios.get(`/api/routes/${this.id}`).then(({data}) => {
                    this.route = data;
                    this.data_loaded = true;
                    this.replaceBreadcrumb({
                        find: '[Route Name]',
                        replace: { text: this.route.title }
                    });                      
	        	});	                
			},

			checkinIndex(checkinId) {
                return this.route.checkins.findIndex((element) => {
                    return element.id === checkinId;
                });
            },

            updateRoute(data) {
				axios.patch(`/api/routes/${this.id}`, data).then(({data})=> {
					console.log('data: ', data);
					this.route.title = data.title;
					this.route.assigned_user = data.assigned_user;
					this.route.complete_by = data.complete_by;
					this.route.status = data.status;
					this.route.status_text = data.status_text;

	                this.$root.$emit('route_updated');
	                this.$store.dispatch('refreshRoutes');
					Swal.fire({
	                    toast: true,
	                    position: 'top-end',
	                    showConfirmButton: false,
	                    timer: 3000,
	                    icon: 'success',
	                    title: 'Route updated',
	                });		                
				});
            },

            updateTerminals(data) {
				axios.patch(`/api/routes/${this.id}/terminals`, data).then(({data})=> {
					this.route.terminals = data.terminals;
					this.route.route_start_other = data.route_start_other;
					this.route.route_end_other = data.route_end_other;
					
					this.$root.$emit('rebuild_map');	                
				});
            },

			clearCheckinModal() {
				this.checkin_options.checkinables = [];
				// {
				// 	morphable_id: '',
				// 	display_name: '',
				// 	morphable_type: '',
				// 	location_id: '',
				// };
				this.$root.$emit('build_checkin_modal', { checkin_options: this.checkin_options });
			},
		},

		computed: {
			...mapState(['config']),

			route_providers() {
		    	if (this.data_loaded) {
		    		return this.route.visits.map(visit => {
		    			if (visit.physician && visit.physician.id) {
			    			return { 
			    				morphable_id: visit.physician.id,
			    				display_name: visit.physician.display_name,
			    				morphable_type: visit.physician.model,
			    				location_id: visit.location_id,
			    			}
			    		} else {
			    			return { 
			    				morphable_id: visit.group.id,
			    				display_name: visit.group.display_name,
			    				morphable_type: visit.group.model,
			    				location_id: visit.location_id
			    			}
			    		}
		    		})
		    	}
		    },
		},

		watch: {
			route_providers() {
				this.checkin_options.ex_providers = this.route_providers;
			},
		},

	}
</script>


<style scoped>

.modal-backdrop {
    z-index: 1040;
}

.modal {
    z-index: 9999;
    background-color:transparent!important;
}

@media (max-width: 767.98px) {
	#quick-add {
		display:none;
	}

	.fill-app-height.without-page-title {
		margin:-10px -15px 0 -15px;
		height:calc(100vh - 55px) !important;
		max-height:calc(100vh - 55px) !important;
	}

}
</style>